import { DataBean } from "../../DataBean";


export class TaxEntityConsecutivetwo extends DataBean {

    public async validateTaxEntityConsecutive(idUBLSoftwareDispatcher: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.ubl.UBLTaxResponse_validateTaxEntityConsecutive_Number", [idUBLSoftwareDispatcher]);
    }

}